import { Mail, Phone, MapPin, Clock } from "lucide-react";
import { InquiryForm } from "@/components/InquiryForm";

export const Contact = () => (
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-testid="contact-page">
    <span className="eyebrow">Get in touch</span>
    <h1 className="mt-4 font-heading text-5xl sm:text-6xl font-semibold text-[#0A3B32] tracking-tight max-w-4xl">
      Have a question? Talk to a BIOMAC counsellor.
    </h1>
    <p className="mt-5 text-lg text-slate-600 max-w-2xl">
      Fill the form and we'll call you within 24 hours, or reach us directly using the
      details below.
    </p>

    <div className="mt-12 grid lg:grid-cols-12 gap-10">
      <div className="lg:col-span-5 space-y-5">
        {[
          { icon: Mail, label: "Email", value: "biomacindiab@gmail.com" },
          { icon: Phone, label: "Phone", value: "+91 84668 64527" },
          { icon: MapPin, label: "Address", value: "BIOMAC Institute · Vijayawada / Tirupati · India" },
          { icon: Clock, label: "Counsellor Hours", value: "Mon–Sat · 10:00 AM – 7:00 PM IST" },
        ].map((c, i) => (
          <div key={c.label} className="card-soft flex items-start gap-4" data-testid={`contact-info-${i}`}>
            <span className="inline-flex w-11 h-11 rounded-xl bg-[#0A3B32]/10 text-[#0A3B32] items-center justify-center shrink-0">
              <c.icon />
            </span>
            <div>
              <p className="text-xs uppercase tracking-wider text-slate-500">{c.label}</p>
              <p className="font-heading text-lg font-semibold text-[#0A3B32]">{c.value}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="lg:col-span-7">
        <InquiryForm />
      </div>
    </div>
  </div>
);
